<template>
  <div class="pages" :style="{backgroundImage:'url('+bgcImg+')'}">
    <input type="text" class="guess-input" v-model="answer" @blur="viewDefault">
    <div class="guess-btn" v-show="isAttend">
      <img src="../../assets/images/btn.png" @click="submitAnswer">
    </div>
    <div class="jump-btn">
      <img src="../../assets/images/jump.png" @click="jumpSite">
    </div>

    <!-- 弹窗 -->
    <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
      <div class="msg-close"><van-icon name="cross" size="23px" color="#888" @click="popCancel"/></div>
      <div class="msg-title">{{ msg.title }}</div>
      <div class="msg-text">{{ msg.text }}</div>
      <div class="msg-btn">
        <van-button v-show="msg.isSuccess" type="primary" size="large" @click="popCancel">取消</van-button>
        <van-button v-show="msg.isSuccess" type="primary" size="large" @click="exchangeBtn">前往</van-button>
        <van-button v-show="!msg.isSuccess" type="primary" size="large" @click="popCancel" style="width: 90px">继续答题</van-button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import activityApi from '@/api/activity'
export default {
  name: 'ActivityDragonBoat',
  data () {
    return {
      answer: '',
      popShow: false,
      msg: {
        title: '',
        text: '',
        isSuccess: Boolean
      },
      scanCode: '',
      bgcImg: require('../../assets/images/activity.png'),
      isAttend: true
    }
  },
  computed: {
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getActivityInfo()
      // commonUtils.configWxJsSdk().catch(error => {
      //   this.$emit('error', { errorMsg: error })
      // })
    },

    // 获取活动信息
    getActivityInfo () {
      let activityCode = 'cm607'
      let timeNow = (new Date()).getTime()
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中'
      })
      activityApi.getActivityInfo(activityCode).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          if (timeNow > res.data.resultData.activity.endDate) {
            this.bgcImg = require('../../assets/images/activity-js.png')
            this.isAttend = false
          } else {
            let url = this.$route.name
            let clientInfo = userUtils.getClientInfo()
            if (!clientInfo) {
              this.$router.push({
                name: 'login',
                params: { redirectUrl: url }
              })
              return false
            }
            this.checkAttend()
          }
        }
      })
    },

    // 判断是否参加过活动
    checkAttend () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中'
      })
      activityApi.checkAttend().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.bgcImg = require('../../assets/images/activity.png')
          this.isAttend = true
        } else {
          this.bgcImg = require('../../assets/images/activity-ed.png')
          this.isAttend = false
        }
      })
    },

    // 提交谜底
    submitAnswer () {
      this.popShow = true
      if (!this.answer) {
        this.msg = {
          title: '谜底为空',
          text: '请填写谜底',
          isSuccess: false
        }
        return false
      }
      if (this.answer !== '粽子') {
        this.msg = {
          title: '回答错误',
          text: '请继续答题',
          isSuccess: false
        }
      } else {
        this.msg = {
          title: '回答正确',
          text: '请领取奖品',
          isSuccess: true
        }
      }
    },

    // 关闭弹窗
    popCancel () {
      this.popShow = false
      if (this.msg.title === '回答错误') {
        this.answer = ''
      }
    },

    // 领取奖品
    exchangeBtn () {
      this.$router.push({
        path: '/activity/dragon-order'
      })
    },

    // 扫码
    showScan () {
      const _vm = this
      _vm.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {},
        fail: function (res) {
          _vm.$toast('调用扫码功能异常')
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 跳转到易加网
    jumpSite () {
      window.location.href = commonUtils.getExtraSite()
    },

    viewDefault () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
.pages {
  height: 100%;
  background-size: 100% auto
}
.scan-btn {
  position: absolute;
  width: 125px;
  height: 31px;
  left: 89px;
  top: 530px;
}
.guess-btn {
  width: 39px;
  height: 23px;
  position: absolute;
  top: 216px;
  left: 217px;
}
.jump-btn {
  width: 160px;
  height: 40px;
  position: absolute;
  top: 528px;
  left: 108px;
}
img {
  width: 100%;
  height: 100%;
}
.guess-input {
  border: 0;
  outline: 0;
  width: 60px;
  text-align: center;
  position: absolute;
  top: 218px;
  left: 145px;
  color: #fff;
  background-color: transparent;
}
.msg-pop {
  width: 210px;
  height: 148px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  .msg-close {
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .msg-title {
    font-size: 18px;
    margin-top: 20px;
    color: #402d26;
  }
  .msg-text {
    font-size: 16px;
    margin-top: 15px;
    color: #402d26;
  }
  .msg-btn {
    display: flex;
    justify-content: center;
    margin-top: 18px;
    .van-button--large {
      width: 65px;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      margin: 0 12px;
    }
  }
}
</style>
